module.exports = {
  "version": "0.26.1"
};


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 91
// module chunks = 0